import styled from 'styled-components';

export const NumberBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  width: 160px;
  margin-right: 24px;
`;

export const NumberValue = styled.span`
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
`;

export const NumberHeader = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #787f88;
`;

export const InfoHeader = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`;
